import R from 'ramda'
import moment from 'moment'


function transformGate (gate) {
  const { _id, stafferRef, time, source } = gate

  return {
    _id,
    stafferRef: {
      _id: stafferRef._id,
      name: stafferRef.name,
    },
    time,
    source,
    type: 'gate',
    renderKey: gate._id,
  }
}
function transformLeave (leave) {
  const { _id, stafferRef, type } = leave

  function build (event) {
    return {
      _id,
      stafferRef: {
        _id: stafferRef._id,
        name: stafferRef.name,
      },
      time: leave[event],
      event,
      type: 'leave',
      leaveType: type,
      renderKey: `${leave._id}_${event}`,
    }
  }

  return [build('start'), build('end')]
}
function transformOvertime (overtime) {
  const { _id, stafferRef } = overtime

  function build (event) {
    return {
      _id,
      stafferRef: {
        _id: stafferRef._id,
        name: stafferRef.name,
      },
      time: overtime[event],
      event,
      type: 'overtime',
      overtimeType: overtime.type,
      renderKey: `${overtime._id}_${event}`,
    }
  }

  return [build('start'), build('end')]
}


function castTimeField (entry) {
  return {
    ...entry,
    time: moment(entry.time).toDate(),
  }
}


function pickStafferIdsFromQuery (query) {
  // stafferRef: {
  //   $in: [
  //     'ObjectId(\'5a0ac105a5609413f497da44\')',
  //     'ObjectId(\'5a0ac105a5609413f497da45\')',
  //   ],
  // },
  const { stafferRef: { $in: stafferQueryArr } } = query

  return R.map(R.slice(10, -2), stafferQueryArr)
}
function buildEmptyStafferEntries (stafferById, query) {
  const stafferIds = pickStafferIdsFromQuery(query)

  return R.map(
    id => {
      const { _id, name } = stafferById[id]
      return {
        _id,
        name,
        items: [],
      }
    },
    stafferIds,
  )
}
function putRecordsInNameEntries (entries, records) {
  const entryById = R.indexBy(({ _id }) => _id, entries)

  R.forEach(
    record => {
      const stafferId = record.stafferRef._id
      entryById[stafferId].items.push(record)
    },
    records,
  )

  return entries
}


function pickDateRangeFromQuery (query) {
  // time: {
  //   $gte: 'Date(\'2016-11-30T16:00:00.000Z\')',
  //   $lte: 'Date(\'2016-12-31T15:59:59.999Z\')',
  // },
  const { time: { $gte: start, $lte: end } } = query

  const sliceDate = R.slice(6, -2)

  return {
    start: sliceDate(start),
    end: sliceDate(end),
  }
}

const isWorkingDic = {
  workday: true,
  holiday: false,
  leave: false,
  dayoff: false,
}
function listAllDates (dateRange, dateByStr = { }) {
  const { start: startStr, end: endStr } = dateRange
  const start = moment(startStr)
  const end = moment(endStr)

  const isWorkday = d => {
    const dateStr = d.format('YYYY-MM-DD')
    if (dateByStr[dateStr]) return isWorkingDic[dateByStr[dateStr].type]
    return d.isoWeekday() < 6
  }

  const dates = []
  const date = moment(start)
  while (date.isSameOrBefore(end)) {
    const dateStr = date.format('YYYY-MM-DD')
    // if (days.includes(dateStr)) toFetch.push(dateStr)
    dates.push({ dateStr, isWorkday: isWorkday(date) })
    date.add(1, 'day')
  }

  return dates
}
function buildEmptyDateEntries (query, dateByStr) {
  const dateRange = pickDateRangeFromQuery(query)
  const dateList = listAllDates(dateRange, dateByStr)

  return R.map(
    d => ({
      ...d,
      items: [],
    }),
    dateList,
  )
}
function putRecordsInDateEntries (query, dateByStr, records) {
  const entries = buildEmptyDateEntries(query, dateByStr)
  const entryByDate = R.indexBy(({ dateStr }) => dateStr, entries)

  // put items in the matched dateEntry
  R.forEach(
    record => {
      const dateStr = moment(record.time).format('YYYY-MM-DD')
      const { stafferRef, ...other } = record
      entryByDate[dateStr].items.push(other)
    },
    records,
  )

  return R.map(
    ({ items, ...other }) => ({
      ...other,
      items: R.sortBy(R.prop('time'))(items),
    }),
    entries,
  )
}

function createNote (items) {
  return R.reduce((pre, item) => {
    if (item.type === 'leave' && item.event === 'start') {
      return (pre ? (pre + ', ') : '') + item.leaveType
    }
    return pre
  }, '', items)
}
function createDailyNote (nameEntries) {
  return R.map(
    ({ items: dateItems, ...other }) => ({
      ...other,
      items: R.map(
        ({ items, ...oth }) => ({
          ...oth,
          items,
          note: createNote(items),
        }),
        dateItems,
      ),
    }),
    nameEntries,
  )
}


function splitByDateAtDepath2 (query, dateByStr, data) {
  return R.map(
    ({ _id, name, items }) => ({
      _id,
      name,
      items: R.pipe(
        R.curry(putRecordsInDateEntries)(query)(dateByStr),
      )(items),
    }),
  )(data)
}

export default function arrangeData (gateData, leaveData, overtimeData,
  stafferById, query, dateByStr) {
  const allData = [].concat(
    R.chain(transformLeave, leaveData),
    R.chain(transformOvertime, overtimeData),
    R.map(transformGate, gateData),
  )

  // TODO use allData to collect stafferIds
  const emptyStafferEntries = buildEmptyStafferEntries(stafferById, query)

  return R.pipe(
    R.map(castTimeField),
    R.curry(putRecordsInNameEntries)(emptyStafferEntries),
    R.curry(splitByDateAtDepath2)(query)(dateByStr),
    createDailyNote,
  )(allData)
}

const forTesting = { }
forTesting.transformGate = transformGate
forTesting.transformLeave = transformLeave
forTesting.transformOvertime = transformOvertime

forTesting.pickStafferIdsFromQuery = pickStafferIdsFromQuery
forTesting.pickDateRangeFromQuery = pickDateRangeFromQuery

forTesting.listAllDates = listAllDates
forTesting.putRecordsInNameEntries = putRecordsInNameEntries
forTesting.putRecordsInDateEntries = putRecordsInDateEntries

forTesting.splitByDateAtDepath2 = splitByDateAtDepath2

export { forTesting }



// WEBPACK FOOTER //
// ./src/components/AttendanceChecker/arrangeData.js